import React from "react";
import Avatar from "react-avatar";

const UserAvatar = ({ user, size = 49, round = true }) => {
  if (!user) {
    return (
      <Avatar
        name="Unknown"
        size={size}
        round={round}
      ></Avatar>
    );
  }

  return (
    <Avatar
      name={user.name || "Unknown"}
      src={user.profileImg}
      size={size}
      round={round}
    ></Avatar>
  );
};
export default UserAvatar;
